import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

/** Components **/
import ForgotPasswordEmailSent from './pages/logIn/ForgotPasswordEmailSent'
import ForgotPasswordCode from './pages/logIn/ForgotPasswordCode'

/** Sign in **/
import LogIn from './pages/logIn/LogIn'
import ForgotPassword from './pages/logIn/ForgotPassword'

/** Redux **/
import { useSelector } from 'react-redux'

/** Main Components */
import { MainContainer } from './components/MainContainer'
import Dashboard from './pages/Dashboard'
import AccountSettings from './pages/AccountSettings'
import CompanySettings from './pages/CompanySettings'
import FieldForms from './pages/FieldForms'
import FormBuilder from './pages/FormBuilder'

/** Utils */
import { Routes as MainRoutes } from './lib/Constants'

const Routes = () => {
  const token = useSelector(state => state.auth.token)
  const user = useSelector(state => state.auth.user)

  if (token && user) {
    return (
      <Switch>
        <MainContainer>
          <Route exact path={MainRoutes.FIELD_FORMS.path}>
            <FieldForms />
          </Route>
          <Route exact path={MainRoutes.DASHBOARD.path}>
            <Dashboard />
          </Route>
          <Route exact path={MainRoutes.COMPANY_SETTINGS.path}>
            <CompanySettings />
          </Route>
          <Route exact path={MainRoutes.ACCOUNT_SETTINGS.path}>
            <AccountSettings />
          </Route>
          <Route path={MainRoutes.FORM_BUILDER.path}>
            <FormBuilder />
          </Route>
        </MainContainer>
      </Switch>
    )
  } else {
    return (
      <Switch>
        <Route exact path="/">
          <Redirect to={MainRoutes.SIGN_IN.path} />
        </Route>
        <Route exact path={MainRoutes.SIGN_IN.path}>
          <LogIn />
        </Route>
        <Route exact path={MainRoutes.FORGOT_PASSWORD.path}>
          <ForgotPassword />
        </Route>
        <Route path={MainRoutes.FORGOT_PASSWORD.SENT.path}>
          <ForgotPasswordEmailSent />
        </Route>
        <Route path={MainRoutes.FORGOT_PASSWORD.CODE.path}>
          <ForgotPasswordCode />
        </Route>
        <Route exact path={MainRoutes.SIGN_IN.path}>
          <LogIn />
        </Route>
        <Route path="*">
          <Redirect to={MainRoutes.ROOT.path} />
        </Route>
      </Switch>
    )
  }
}

export default Routes
